import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const T = {
  ru: {
    nav_login: 'Войти',
    nav_register: 'Начать',
    hero_badge: 'Ведическая астрология · Джйотиш',
    hero_title: 'Благоприятный момент\nдля покупки недвижимости',
    hero_sub: 'Точный астрологический расчёт по дате рождения. Узнайте, когда звёзды\nблагоприятствуют вашей сделке.',
    hero_cta: 'Рассчитать даты',
    hero_cta2: 'Как это работает',
    trust1: 'Swiss Ephemeris',
    trust1s: 'Профессиональные эфемериды',
    trust2: '7 уровней анализа',
    trust2s: 'Панчанга, транзиты, даша',
    trust3: 'ИИ-объяснения',
    trust3s: 'Claude AI для каждого дня',
    how_title: 'Как работает расчёт',
    step1_t: 'Введите данные рождения',
    step1_s: 'Дата, время и место рождения для построения натальной карты',
    step2_t: 'Укажите период',
    step2_s: 'Выберите диапазон дат до 6 месяцев для анализа',
    step3_t: 'Получите результат',
    step3_s: 'Цветной календарь с оценкой каждого дня и AI-объяснением',
    layers_title: 'Семь слоёв анализа',
    layers: [
      ['ॐ', 'Панчанга', 'Титхи, Вара, Накшатра, Йога, Карана — лунный календарь дня'],
      ['☽', 'Чандра-бала', 'Сила Луны относительно вашей натальной позиции'],
      ['✦', 'Тара-бала', 'Гармония текущей накшатры с накшатрой рождения'],
      ['⊕', 'Натальная карта', 'Анализ 4-го дома недвижимости в вашей карте'],
      ['♄', 'Транзиты планет', 'Влияние Юпитера, Сатурна, Марса на сделку'],
      ['◎', 'Раху-кала', 'Блокировка опасных временных окон каждого дня'],
      ['⟳', 'Вимшоттари Даша', 'Ваш текущий жизненный период по Луне'],
    ],
    pricing_title: 'Тарифы',
    pricing_sub: 'Разовая оплата — доступ навсегда',
    plan1_name: 'Личный',
    plan1_price: '$49',
    plan1_desc: 'Для частного покупателя',
    plan1_features: [
      'Один профиль (ваши данные рождения)',
      'Неограниченные расчёты навсегда',
      'Цветной календарь до 6 мес.',
      'AI-объяснение каждого дня',
      'PDF-отчёт с топ-5 датами',
    ],
    plan2_name: 'Профессиональный',
    plan2_price: '$149',
    plan2_badge: 'Для риэлтора',
    plan2_desc: 'Для агентств недвижимости',
    plan2_features: [
      'Неограниченное число клиентов',
      'Все функции личного тарифа',
      'История клиентских профилей',
      'PDF с логотипом агентства',
      'Приоритетная поддержка',
    ],
    plan_cta: 'Выбрать тариф',
    faq_title: 'Частые вопросы',
    faqs: [
      ['На чём основаны расчёты?',
       'Мы используем Swiss Ephemeris — профессиональную астрологическую библиотеку, которую применяют ведущие астрологи мира. Расчёт включает 7 слоёв анализа по системе Джйотиш.'],
      ['Нужно знать точное время рождения?',
       'Желательно — оно влияет на точность Лагны (асцендента). Если время неизвестно, расчёт всё равно выполняется по остальным слоям анализа.'],
      ['Подходит ли для продажи недвижимости?',
       'Да. Приложение рассчитывает благоприятные даты как для покупки, так и для продажи. При запросе расчёта выберите тип сделки.'],
      ['Как работают AI-объяснения?',
       'Каждый день сопровождается персонализированным объяснением от Claude AI (Anthropic), которое переводит астрологические показатели в понятный язык для вашего клиента.'],
      ['Есть ли возврат средств?',
       'Если в течение 24 часов после оплаты вы столкнётесь с технической проблемой — вернём деньги без вопросов. Напишите на support@astrodata.app.'],
    ],
    footer_copy: '© 2026 AstraData. Ведическая астрология для недвижимости.',
  },
  uk: {
    nav_login: 'Увійти',
    nav_register: 'Почати',
    hero_badge: 'Ведична астрологія · Джйотіш',
    hero_title: 'Сприятливий момент\nдля купівлі нерухомості',
    hero_sub: 'Точний астрологічний розрахунок за датою народження. Дізнайтесь, коли зірки\nсприяють вашій угоді.',
    hero_cta: 'Розрахувати дати',
    hero_cta2: 'Як це працює',
    trust1: 'Swiss Ephemeris',
    trust1s: 'Професійні ефемериди',
    trust2: '7 рівнів аналізу',
    trust2s: 'Панчанга, транзити, даша',
    trust3: 'ШІ-пояснення',
    trust3s: 'Claude AI для кожного дня',
    how_title: 'Як працює розрахунок',
    step1_t: 'Введіть дані народження',
    step1_s: 'Дата, час і місце народження для побудови натальної карти',
    step2_t: 'Вкажіть період',
    step2_s: 'Виберіть діапазон дат до 6 місяців для аналізу',
    step3_t: 'Отримайте результат',
    step3_s: 'Кольоровий календар з оцінкою кожного дня та AI-поясненням',
    layers_title: 'Сім рівнів аналізу',
    layers: [
      ['ॐ', 'Панчанга', 'Тітхі, Вара, Накшатра, Йога, Карана — місячний календар дня'],
      ['☽', 'Чандра-бала', 'Сила Місяця відносно вашої натальної позиції'],
      ['✦', 'Тара-бала', 'Гармонія поточної накшатри з накшатрою народження'],
      ['⊕', 'Натальна карта', 'Аналіз 4-го будинку нерухомості у вашій карті'],
      ['♄', 'Транзити планет', 'Вплив Юпітера, Сатурна, Марса на угоду'],
      ['◎', 'Раху-кала', 'Блокування небезпечних часових вікон кожного дня'],
      ['⟳', 'Вімшоттарі Даша', 'Ваш поточний життєвий період за Місяцем'],
    ],
    pricing_title: 'Тарифи',
    pricing_sub: 'Одноразова оплата — доступ назавжди',
    plan1_name: 'Особистий',
    plan1_price: '$49',
    plan1_desc: 'Для приватного покупця',
    plan1_features: [
      'Один профіль (ваші дані народження)',
      'Необмежені розрахунки назавжди',
      'Кольоровий календар до 6 міс.',
      'AI-пояснення кожного дня',
      'PDF-звіт з топ-5 датами',
    ],
    plan2_name: 'Професійний',
    plan2_price: '$149',
    plan2_badge: 'Для рієлтора',
    plan2_desc: 'Для агентств нерухомості',
    plan2_features: [
      "Необмежена кількість клієнтів",
      'Всі функції особистого тарифу',
      'Історія клієнтських профілів',
      'PDF з логотипом агентства',
      'Пріоритетна підтримка',
    ],
    plan_cta: 'Обрати тариф',
    faq_title: 'Часті запитання',
    faqs: [
      ['На чому засновані розрахунки?',
       'Ми використовуємо Swiss Ephemeris — професійну астрологічну бібліотеку, яку застосовують провідні астрологи світу. Розрахунок включає 7 рівнів аналізу за системою Джйотіш.'],
      ['Чи потрібно знати точний час народження?',
       'Бажано — він впливає на точність Лагни (асцендента). Якщо час невідомий, розрахунок все одно виконується за іншими рівнями аналізу.'],
      ['Чи підходить для продажу нерухомості?',
       'Так. Застосунок розраховує сприятливі дати як для купівлі, так і для продажу. При запиті розрахунку оберіть тип угоди.'],
      ['Як працюють AI-пояснення?',
       'Кожен день супроводжується персоналізованим поясненням від Claude AI (Anthropic), яке перекладає астрологічні показники на зрозумілу мову для вашого клієнта.'],
      ['Чи є повернення коштів?',
       'Якщо протягом 24 годин після оплати виникне технічна проблема — повернемо кошти без питань. Напишіть на support@astrodata.app.'],
    ],
    footer_copy: '© 2026 AstraData. Ведична астрологія для нерухомості.',
  },
};

export default function LandingPage({ lang = 'ru', onLangChange }) {
  const navigate = useNavigate();
  const t = T[lang] || T.ru;
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div className="landing">
      {/* NAV */}
      <nav className="landing-nav">
        <div className="landing-nav-logo">
          <span className="logo-om">ॐ</span>
          <span className="logo-text">AstraData</span>
        </div>
        <div className="landing-nav-right">
          <button
            className="lang-toggle"
            onClick={() => onLangChange && onLangChange(lang === 'ru' ? 'uk' : 'ru')}
          >
            {lang === 'ru' ? 'UA' : 'RU'}
          </button>
          <button className="btn btn-ghost" onClick={() => navigate('/login')}>
            {t.nav_login}
          </button>
          <button className="btn btn-gold" onClick={() => navigate('/register')}>
            {t.nav_register}
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-bg">
          <div className="mandala mandala-1" />
          <div className="mandala mandala-2" />
          <div className="stars-field" />
        </div>
        <div className="hero-content">
          <span className="hero-badge">{t.hero_badge}</span>
          <h1 className="hero-title">
            {t.hero_title.split('\n').map((l, i) => (
              <span key={i}>{l}{i === 0 && <br />}</span>
            ))}
          </h1>
          <p className="hero-sub">
            {t.hero_sub.split('\n').map((l, i) => (
              <span key={i}>{l}{i === 0 && <br />}</span>
            ))}
          </p>
          <div className="hero-actions">
            <button className="btn btn-gold btn-lg" onClick={() => navigate('/free')}>
              {lang === 'uk' ? 'Безкоштовне сканування' : 'Бесплатное сканирование'}
            </button>
            <button className="btn btn-outline-gold btn-lg" onClick={() => navigate('/demo')}>
              {lang === 'uk' ? 'Подивитись приклад' : 'Посмотреть пример'}
            </button>
          </div>

          {/* Trust badges */}
          <div className="trust-row">
            {[
              ['⚡', t.trust1, t.trust1s],
              ['✦', t.trust2, t.trust2s],
              ['✨', t.trust3, t.trust3s],
            ].map(([icon, title, sub]) => (
              <div className="trust-badge" key={title}>
                <span className="trust-icon">{icon}</span>
                <div>
                  <div className="trust-title">{title}</div>
                  <div className="trust-sub">{sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="section section-dark">
        <div style={{maxWidth:960,margin:'0 auto',padding:'0 16px'}}>
          <h2 style={{textAlign:'center',marginBottom:8}}>{lang === 'uk' ? 'Що ви отримаєте' : 'Что вы получите'}</h2>
          <p style={{textAlign:'center',color:'#a09070',marginBottom:28}}>
            {lang === 'uk' ? 'Не загальні поради, а конкретні дати саме для вашої угоди' : 'Не общие советы, а конкретные даты именно для вашей сделки'}
          </p>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:14}}>
            {(lang === 'uk' ? [
              ['⭐','5 найкращих дат','Для підписання договору, внесення завдатку чи заселення — з оцінкою від 0 до 100'],
              ['⛔','Дні, яких варто уникати','Застосунок підсвічує несприятливі періоди, щоб не втратити час і гроші'],
              ['🗓️','Кольоровий календар','До 6 місяців наперед: зелені дні — діємо, червоні — відкладаємо'],
              ['💬','Пояснення простою мовою','З чого складена оцінка кожного дня — можна показати клієнту'],
              ['📄','PDF-звіт','Готовий документ з найкращими датами для клієнта чи родини'],
            ] : [
              ['⭐','5 лучших дат','Для подписания договора, задатка или заселения — с оценкой от 0 до 100'],
              ['⛔','Дни, которых стоит избегать','Приложение подсвечивает неблагоприятные периоды, чтобы не терять время и деньги'],
              ['🗓️','Цветной календарь','До 6 месяцев вперёд: зелёные дни — действуем, красные — откладываем'],
              ['💬','Объяснение простым языком','Из чего сложилась оценка каждого дня — можно показать клиенту'],
              ['📄','PDF-отчёт','Готовый документ с лучшими датами для клиента или семьи'],
            ]).map(([ic,ti,tx]) => (
              <div key={ti} style={{background:'#13112a',border:'1px solid #2a2244',borderRadius:14,padding:18}}>
                <div style={{fontSize:26,marginBottom:6}}>{ic}</div>
                <div style={{fontWeight:600,marginBottom:4}}>{ti}</div>
                <div style={{fontSize:13,color:'#a09070',lineHeight:1.5}}>{tx}</div>
              </div>
            ))}
          </div>
          <div style={{textAlign:'center',marginTop:26}}>
            <button className="btn btn-gold btn-lg" onClick={() => navigate('/demo')}>
              {lang === 'uk' ? 'Подивитись готовий результат' : 'Посмотреть готовый результат'}
            </button>
          </div>
        </div>
      </section>

      <section id="how" className="section">
        <div className="section-inner">
          <h2 className="section-title">{t.how_title}</h2>
          <div className="steps-row">
            {[
              [t.step1_t, t.step1_s, '01'],
              [t.step2_t, t.step2_s, '02'],
              [t.step3_t, t.step3_s, '03'],
            ].map(([title, sub, num]) => (
              <div className="step-card" key={num}>
                <div className="step-num">{num}</div>
                <h3 className="step-title">{title}</h3>
                <p className="step-sub">{sub}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 7 LAYERS */}
      <section className="section section-dark">
        <div className="section-inner">
          <h2 className="section-title">{t.layers_title}</h2>
          <div className="layers-grid">
            {t.layers.map(([icon, title, desc]) => (
              <div className="layer-card" key={title}>
                <div className="layer-icon">{icon}</div>
                <div className="layer-title">{title}</div>
                <div className="layer-desc">{desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CALENDAR PREVIEW */}
      <section className="section">
        <div className="section-inner" style={{ textAlign: 'center' }}>
          <h2 className="section-title">Результат расчёта</h2>
          <div className="calendar-preview">
            <div className="cal-header">
              <span>◁</span>
              <span style={{ fontFamily: 'Playfair Display, serif', fontSize: '18px' }}>Июнь 2026</span>
              <span>▷</span>
            </div>
            <div className="cal-days-row">
              {['Пн','Вт','Ср','Чт','Пт','Сб','Вс'].map(d => (
                <div key={d} className="cal-day-hdr">{d}</div>
              ))}
            </div>
            <div className="cal-grid">
              {DEMO_DAYS.map((d, i) => (
                <div key={i} className={`cal-cell cal-${d.c}`}>
                  {d.n && <span className="cal-num">{d.n}</span>}
                  {d.n && d.c === 'excellent' && <span className="cal-star">✦</span>}
                </div>
              ))}
            </div>
            <div className="cal-legend">
              {[['excellent','80–100', 'Отлично'],['good','60–79','Хорошо'],
                ['neutral','40–59','Нейтрально'],['poor','20–39','Нежелательно'],['bad','0–19','Избегать']
              ].map(([c, score, label]) => (
                <div className="legend-item" key={c}>
                  <div className={`legend-dot legend-dot-${c}`} />
                  <span>{label} {score}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="section section-dark">
        <div className="section-inner">
          <h2 className="section-title">{t.pricing_title}</h2>
          <p className="section-sub">{t.pricing_sub}</p>
          <div className="plans-row">
            {/* Plan 1 */}
            <div className="plan-card">
              <div className="plan-name">{t.plan1_name}</div>
              <div className="plan-price">{t.plan1_price}</div>
              <div className="plan-desc">{t.plan1_desc}</div>
              <ul className="plan-features">
                {t.plan1_features.map(f => (
                  <li key={f}><span className="plan-check">✓</span>{f}</li>
                ))}
              </ul>
              <button className="btn btn-outline-gold btn-full" onClick={() => navigate('/register?plan=personal')}>
                {t.plan_cta}
              </button>
            </div>
            {/* Plan 2 */}
            <div className="plan-card plan-card-featured">
              <div className="plan-badge-featured">{t.plan2_badge}</div>
              <div className="plan-name">{t.plan2_name}</div>
              <div className="plan-price">{t.plan2_price}</div>
              <div className="plan-desc">{t.plan2_desc}</div>
              <ul className="plan-features">
                {t.plan2_features.map(f => (
                  <li key={f}><span className="plan-check">✓</span>{f}</li>
                ))}
              </ul>
              <button className="btn btn-gold btn-full" onClick={() => navigate('/register?plan=professional')}>
                {t.plan_cta}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section">
        <div className="section-inner section-narrow">
          <h2 className="section-title">{t.faq_title}</h2>
          <div className="faq-list">
            {t.faqs.map(([q, a], i) => (
              <div className="faq-item" key={i}>
                <button
                  className={`faq-q ${openFaq === i ? 'faq-q-open' : ''}`}
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  <span>{q}</span>
                  <span className="faq-arrow">{openFaq === i ? '▲' : '▼'}</span>
                </button>
                {openFaq === i && <div className="faq-a">{a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="landing-footer">
        <div className="logo-om">ॐ</div>
        <p>{t.footer_copy}</p>
        <div className="footer-links">
          <a href="#pricing">Тарифы</a>
          <span>·</span>
          <a href="mailto:support@astrodata.app">Поддержка</a>
        </div>
      </footer>
    </div>
  );
}

// Demo calendar data
const DEMO_DAYS = [
  {n:null,c:'empty'},{n:null,c:'empty'},{n:'1',c:'neutral'},{n:'2',c:'good'},
  {n:'3',c:'poor'},{n:'4',c:'bad'},{n:'5',c:'bad'},
  {n:'6',c:'neutral'},{n:'7',c:'good'},{n:'8',c:'excellent'},{n:'9',c:'good'},
  {n:'10',c:'poor'},{n:'11',c:'neutral'},{n:'12',c:'bad'},
  {n:'13',c:'excellent'},{n:'14',c:'good'},{n:'15',c:'poor'},{n:'16',c:'neutral'},
  {n:'17',c:'good'},{n:'18',c:'excellent'},{n:'19',c:'poor'},
  {n:'20',c:'bad'},{n:'21',c:'neutral'},{n:'22',c:'good'},{n:'23',c:'excellent'},
  {n:'24',c:'good'},{n:'25',c:'neutral'},{n:'26',c:'poor'},
  {n:'27',c:'bad'},{n:'28',c:'neutral'},{n:'29',c:'good'},{n:'30',c:'excellent'},
  {n:null,c:'empty'},{n:null,c:'empty'},{n:null,c:'empty'},
];
